import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { InactivityService } from 'src/app/services/inactivity/inactivity.service';
import { TokenRefreshService } from 'src/app/services/inactivity/token-refresh.service';

export async function sessionRecoveryInitializer(): Promise<void> {
  const auth = inject(AuthService);
  const inactivity = inject(InactivityService);
  inject(TokenRefreshService);

  const isAuthenticated = await firstValueFrom(auth.isAuthenticated$.pipe(take(1)));
  if (!isAuthenticated) {
    return;
  }

  inactivity.initializeSession(true);
}
